module.exports = __webpack_public_path__ + "static/media/referee.c805ada4.svg";